import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import './link.css';

const Link = ({
    children,
    to,
    className = '',
    onClick,
    disabled = false,
    ...props
}) => {
    if (disabled) {
        return (
            <span className="custom-link-disabled text-body">
                {children}
            </span>
        );
    }

    return (
        <RouterLink
            to={to}
            className={`custom-link text-body ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </RouterLink>
    );
};

export default Link;
